var _polyline, _line, _polyline2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyntax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "syntax",
    viewBox: "0 0 640 640",
    fill: "none",
    stroke: "#666",
    strokeWidth: 40,
    strokeLinecap: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "196.2,204.1 25.9,332.1 196.2,434.9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 265,
    y1: 476.7,
    x2: 398,
    y2: 163.1
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "444.8,434.9 615.1,332.1 444.8,204.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyntax);
export default __webpack_public_path__ + "static/media/syntax.a216857b2beb604acd52fea86e7fdd75.svg";
export { ForwardRef as ReactComponent };